import { List, SaveButton, useEditableTable } from '@refinedev/antd';
import { Button, Form, Select, Space, Table } from 'antd';
import { IOperator, IOperatorRole } from '../../interfaces/operator';

const OperatorRole: Record<IOperatorRole, string> = {
  admin: '管理者',
  staff: 'オペレーター',
};

const OperatorRoleOptions = Object.entries(OperatorRole).map(([value, label]) => ({
  value,
  label,
}));

export const OperatorList = () => {
  const {
    tableProps,
    formProps,
    isEditing,
    saveButtonProps,
    cancelButtonProps,
    setId: setEditId,
  } = useEditableTable<IOperator>({
    resource: 'operators',
    sorters: {
      initial: [{ field: 'createdAt', order: 'desc' }],
    },
    meta: {
      fields: ['id', 'email', 'role'],
    },
    mutationMeta: {
      fields: [{ operator: ['id', 'email', 'role'] }],
    },
  });

  return (
    <List resource="operators" headerProps={{ title: '管理者' }}>
      <Form {...formProps}>
        <Table
          {...tableProps}
          rowKey="id"
          pagination={{
            ...tableProps.pagination,
            showSizeChanger: true,
            showTotal: (total) => `全${total}件`,
          }}
          onRow={(record) => ({
            onClick: (event: any) => {
              if (event.target.nodeName === 'TD') {
                setEditId && setEditId(record.id);
              }
            },
          })}
        >
          <Table.Column dataIndex="email" title="Email" />
          <Table.Column
            dataIndex="role"
            title="ロール"
            render={(value: IOperatorRole, data: IOperator) =>
              isEditing(data.id) ? (
                <Form.Item name="role" style={{ margin: 0 }}>
                  <Select options={OperatorRoleOptions} />
                </Form.Item>
              ) : (
                OperatorRole[value]
              )
            }
          />
          <Table.Column<IOperator>
            dataIndex="actions"
            render={(_, record) =>
              isEditing(record.id) ? (
                <Space>
                  <SaveButton {...saveButtonProps} size="small" />
                  <Button {...cancelButtonProps} size="small">
                    キャンセル
                  </Button>
                </Space>
              ) : (
                <Space></Space>
              )
            }
          />
        </Table>
      </Form>
    </List>
  );
};
